import React from "react";
import location from "../../../assets/img/icons/location 2.svg";
import PersianNumber from "../../shared/PersianNumber";
const Placetitle = ({ inforesidencedetail }) => {
  return (
    <div className="Placetitle mb-[36px]">
      <div className="center w-max py-[6px] px-[16px] bg-[#F1C31F] rounded-[50px] text-[16px] font-[600] text-[#12171C] flex justify-center items-center">
        <p className="">
          کد آگهی :
        </p>
        <p>
         <PersianNumber number={inforesidencedetail.code}/>
        </p>
      </div>

      <div className=" flex justify-between items-center mt-[16px]">
        <h2 className="text-[24px] font-[900] text-[#12171C]">
         {inforesidencedetail.title}
        </h2>
        <div className="flex items-center">
          <img src={location} />
          <p className="text-[18px] font-[700] text-[#12171C] mr-[8px]">
            استان {inforesidencedetail.city.state} ، {inforesidencedetail.city.title}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Placetitle;
